import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { selectReadOnly } from 'store/Faraday/selectors';
import AddButton from 'Common/Components/AddButton';
import { selectActiveWorkspacesCount } from 'store/Global/selectors';
import { openModal } from 'store/modals/actions';
import { MODAL_CANT_CREATE } from 'store/modals/modals';

const CreateActions = ({ setVisibilityCreateModal, entity }) => {
  const intl = useIntl();
  const addText = intl.formatMessage({ id: 'host.create' });
  const readOnly = useSelector(selectReadOnly);
  const canUpdate = !readOnly;
  const activeWorkspacesCount = useSelector(selectActiveWorkspacesCount);
  const dispatch = useDispatch();

  const handleShow = () => {
    if (entity === 'assetsGeneral' && !activeWorkspacesCount) {
      dispatch(openModal(MODAL_CANT_CREATE));
    } else if (entity === 'assetsGeneral' || canUpdate) {
      setVisibilityCreateModal(true);
    }
  };

  return (
    <AddButton
      onClick={ handleShow }
      title={ addText }
      text={ addText }
      disabled={ entity !== 'assetsGeneral' && readOnly }
    />
  );
};

export default CreateActions;
